import { createGlobalStyle } from '../styled'

/** Set of CSS resets to unify styles across browsers and provide good style defaults. */
export default createGlobalStyle`
	html {
		box-sizing: border-box;
		line-height: 1.4;
		-webkit-text-size-adjust: 100%;
	}

	*, *::before, *::after {
		border-style: solid;
		border-width: 0;
		box-sizing: inherit;
	}

	body {
		margin: 0;
	}

	a {
		background-color: transparent;
		color: inherit;
		text-decoration: none;
	}

	abbr[title] {
		border-bottom: none;
		text-decoration: underline dotted;
	}

	b, strong {
		font-weight: bolder;
	}

	button {
		cursor: pointer;
		-webkit-appearance: button;
	}

	button, input, optgroup, select, textarea {
		font-family: inherit;
		font-size: 100%;
		margin: 0;
	}

	button, select {
		text-transform: none;
	}

	code, kbd, pre, samp {
		font-family: ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace;
		font-size: 1em;
	}

	details {
		display: block;
	}

	fieldset {
		padding: 0.35em 0.75em 0.625em;
	}

	h1, h2, h3, h4, h5, h6, p, hr, dl, dd, blockquote, figure, pre {
		margin: 0;
	}

	h1, h2, h3, h4, h5, h6 {
		font-size: inherit;
		font-weight: inherit;
	}

	hr {
		color: inherit;
		height: 0;
	}

	img {
		border-style: none;
	}

	img, svg, video, canvas, audio, iframe, embed, object {
		display: block;
	}

	legend {
		color: inherit;
		display: table;
		max-width: 100%;
		padding: 0;
		white-space: normal;
	}

	main {
		display: block;
	}

	ol, ul  {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	progress {
		vertical-align: baseline;
	}

	summary {
		display: list-item;
	}

	small {
		font-size: 80%;
	}

	sub, sup {
		font-size: 75%;
		line-height: 0;
		position: relative;
		vertical-align: baseline;
	}

	sub {
		bottom: -0.25em;
	}

	sup {
		top: -0.5em;
	}

	table {
		text-indent: 0;
		border-color: inherit;
	}

	template {
		display: none;
	}

	textarea {
		overflow: auto;
	}

	::-moz-focus-inner {
		border-style: none;
		padding: 0;
	}

	::-webkit-file-upload-button {
		font: inherit;
		-webkit-appearance: button;
	}

	[type=checkbox], [type=radio] {
		padding: 0;
	}

	[type=number]::-webkit-inner-spin-button,
	[type=number]::-webkit-outer-spin-button {
		height: auto;
	}

	[type=search] {
		outline-offset: -2px;
		-webkit-appearance: textfield;
	}

	[type=search]::-webkit-search-decoration {
		-webkit-appearance: none;
	}

	[hidden] {
		display: none;
	}
`
